import { dateFormats, diffInSeconds, parseDate } from '@nextinq/domain';

const connectionLimitSeconds = 3 * 60;

export function getConnectionStatus(dtOrString: any) {
  if (!dtOrString) {
    return 'unknown';
  }
  const dt = parseDate(dtOrString);
  if (!dt || dt.getFullYear() < 2000) {
    return 'neverConnected';
  }
  const diff = diffInSeconds(dt);
  return diff < connectionLimitSeconds ? 'connected' : 'disconnected';
}

export default function formatLastSeenOnline(val: any) {
  if (!val) {
    return '?';
  }
  const dt = parseDate(val);
  if (dt?.getFullYear() || 0 < 2000) {
    return '?';
  }
  return `${dateFormats.short.dateTime(dt)}`;
}
